// extracted by mini-css-extract-plugin
module.exports = {"main":"NoResults_main__xrpm7","subCopy":"NoResults_subCopy__oBCOA"};